<template>
  <b-row>
    <b-col md="12">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <b-row class="mb-5">
          <b-col md="12" class="text-right">
            <!-- <b-button variant="primary" @click="showProductModal"><font-awesome-icon icon="plus"/> Tambah Photo Barang</b-button>
            <b-button variant="primary" @click="showProductColorModal"><font-awesome-icon icon="plus"/> Tambah Photo Barang / Warna</b-button> -->
            <b-button variant="success" :to="'/barang/ubah-harga/' + $route.params.id"><font-awesome-icon icon="money-bill"/> Ubah Harga</b-button>
            <b-button :variant="!addProduct ? 'primary' : 'warning'" @click="addProduct = !addProduct"><font-awesome-icon :icon="!addProduct ? 'plus' : 'times'"/> {{!addProduct ? 'Tambah Warna Barang' : 'Batal'}}</b-button>
          </b-col>
        </b-row>
        <b-row v-if="addProduct" class="mt-5 mb-5">
          <b-col md="12">
            <form v-on:submit.prevent="doSubmit">
              <b-row class="border ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in lines" v-bind:key="index">
                <b-col md="5">
                  <fg-input label="Warna">
                    <treeselect 
                      v-model="line.color" 
                      class="mb-3" 
                      placeholder="Pilih warna" 
                      :multiple="false"
                      :clear-on-select="true"
                      :options="colorList" 
                      name="color"
                      data-vv-as="color" ></treeselect>
                  </fg-input>
                </b-col>
                <b-col md="5">
                  <fg-input label="Ukuran">
                    <treeselect 
                      v-model="line.size" 
                      class="mb-3" 
                      placeholder="Pilih ukuran" 
                      :multiple="true"
                      :clear-on-select="true"
                      :options="sizeList"
                      @input="getData(line.size, index)"
                      name="size"
                      data-vv-as="size" ></treeselect>
                  </fg-input>
                </b-col>
                <b-col md="1 p-0 mt-4-5 text-center">
                  <button @click="removeLine(index)" v-if="index >= 1" class="btn btn-danger"><i class="fa fa-times"></i></button>
                </b-col>
                <b-col md="1 p-0 mt-4-5 text-center">
                  <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
                </b-col>
                <b-col md="12">
                  <b-row v-for="(lineSize, lineIndex) in line.model" :key="lineIndex">
                    <b-col md="12">
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="capitalPrice" type="number" name="capitalPrice" id="capitalPrice" label="Harga Beli" placeholder="Enter Name" v-model="lineSize.capitalPrice" :error="errors.first('capitalPrice')" data-vv-as="harga beli"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="sellingPrice" type="number" name="sellingPrice" id="sellingPrice" label="Harga Jual" placeholder="Enter Name" v-model="lineSize.sellingPrice" :error="errors.first('sellingPrice')" data-vv-as="harga jual"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="memberPrice" type="number" name="memberPrice" id="memberPrice" label="Harga Member" placeholder="Enter Name" v-model="lineSize.memberPrice" :error="errors.first('memberPrice')" data-vv-as="harga member"/>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="smPrice" type="number" name="smPrice" id="smPrice" label="Harga spesial member" placeholder="Enter Name" v-model="lineSize.smPrice" :error="errors.first('smPrice')" data-vv-as="harga sepesial member"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="more3" type="number" name="more3" id="more3" label="Harga lebih dari 3" placeholder="Enter Name" v-model="lineSize.more3" :error="errors.first('more3')" data-vv-as="harga lebih dari 3"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="more12" type="number" name="more12" id="more12" label="Harga lebih dari 12" placeholder="Enter Name" v-model="lineSize.more12" :error="errors.first('more12')" data-vv-as="harga lebih dari 3"/>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4 pl-4">
                          <fg-input :required="true" for-input="dropshipper" type="number" name="dropshipper" id="dropshipper" label="Harga dropshipper" placeholder="Enter Name" v-model="lineSize.dropshipper" :error="errors.first('dropshipper')" data-vv-as="harga dropshipper"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="gold_member" type="number" name="gold_member" id="gold_member" label="Harga gold member" placeholder="Enter Name" v-model="lineSize.gold_member" :error="errors.first('gold_member')" data-vv-as="harga gold member"/>
                        </b-col>
                        <b-col md="4">
                          <fg-input :required="true" for-input="stock" type="number" name="stock" id="stock" label="Stok" placeholder="Enter Name" :error="errors.first('stock')" v-model="lineSize.stock" data-vv-as="Stok"/>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-button :variant="!addProduct ? 'primary' : 'warning'" class="float-left" @click="addProduct = !addProduct"><font-awesome-icon :icon="!addProduct ? 'plus' : 'times'"/> {{!addProduct ? 'Tambah Warna Barang' : 'Batal'}}</b-button>

              <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id !== undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
              
            </form>
          </b-col>
        </b-row>
        <div class="row mb-5">
           <div class="col-md-6">
              <fg-input label="Kode">
                <p>{{model.code}}</p>
              </fg-input>
              <fg-input label="Name">
                <!-- <p>{{model.name}}</p> -->
                <div class="form-row" v-if="isFieldCode">
                  <div class="col">
                    <fg-input :required="true" for-input="Name" type="text" name="name" id="Name" placeholder="Enter Name" v-model="setFieldCode"/>
                  </div>
                  <div class="col">
                    <b-button variant="warning" @click="batalFieldCode"><font-awesome-icon icon="times"/> Batal</b-button>
                    <b-button variant="success" @click="simpanFieldCode"><font-awesome-icon icon="save"/> Simpan</b-button>
                  </div>
                </div>
                <p v-else @click="editFieldCode(model.name)" >{{model.name}}</p>
              </fg-input>
              <fg-input label="Kategori">
                <p>{{model.category.category.name}}</p>
              </fg-input>
              <fg-input label="Active">
                <p><l-switch :width="30" v-model="model.isActive" type="primary" :active-value="1" :inactive-value="0" @change="changeSwitch('isActive', 'Available',  model.isActive)"></l-switch></p>
              </fg-input>
           </div>
           <b-col md="6">
              <fg-input label="Dibuat Oleh">
                <p>{{model.createdBy.name}}</p>
              </fg-input>
              <fg-input label="DIperbarui Oleh">
                <p>{{model.lastUpdatedBy.name}}</p>
              </fg-input>
              <fg-input label="Deskripsi Barang">
                <p><div v-html="model.description !== null ? model.description : '-'"></div></p>
              </fg-input>
           </b-col>
        </div>
        <b-row>
          <b-col md="12">
            <h3 class="border-bottom"><strong>Photo Barang</strong></h3>
          </b-col>
          <b-col md="2">
            <fg-input label="Photo 1">
              <div v-viewer>
                <label v-if="model.photo1 === null" class="text-secondary top-padding-6">No photo submitted</label>
                <div v-else style="position: relative; max-width: 300px; display: inline-block; margin-right: 10px;">
                  <b-img
                      class="icon-large img-fluid"
                      :src="getPath(model.photo1)" />
                </div>
              </div>
            </fg-input>
          </b-col>
          <b-col md="2">
            <fg-input label="Photo 2">
              <div v-viewer>
                <label v-if="model.photo2 === null" class="text-secondary top-padding-6">No photo submitted</label>
                <div v-else style="position: relative; max-width: 300px; display: inline-block; margin-right: 10px;">
                  <b-img
                      class="icon-large img-fluid"
                      :src="getPath(model.photo2)" />
                </div>
              </div>
            </fg-input>
          </b-col>
          <b-col md="2">
            <fg-input label="Photo 3">
              <div v-viewer>
                <label v-if="model.photo3 === null" class="text-secondary top-padding-6">No photo submitted</label>
                <div v-else style="position: relative; max-width: 300px; display: inline-block; margin-right: 10px;">
                  <b-img
                      class="icon-large img-fluid"
                      :src="getPath(model.photo3)" />
                </div>
              </div>
            </fg-input>
          </b-col>
          <b-col md="2">
            <fg-input label="Photo 4">
              <div v-viewer>
                <label v-if="model.photo4 === null" class="text-secondary top-padding-6">No photo submitted</label>
                <div v-else style="position: relative; max-width: 300px; display: inline-block; margin-right: 10px;">
                  <b-img
                      class="icon-large img-fluid"
                      :src="getPath(model.photo4)" />
                </div>
              </div>
            </fg-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col md="12" v-for="color in model.category.product_color" :key="color.id">
            <fg-input label="Warna">
              <p>{{color.color.name}}</p>
            </fg-input>
            <fg-input label="Photo Barang / Warna">
              <div v-viewer>
                <label v-if="color.photo_color === null" class="text-secondary top-padding-6">No photo submitted</label>
                <div v-else style="position: relative; max-width: 100px; display: inline-block; margin-right: 10px;">
                  <b-img
                      class="icon-large img-fluid"
                      :src="getPath(color.photo_color)" />
                </div>
              </div>
            </fg-input>
            <div class="table-responsive">
              <b-button variant="primary" @click="ShowModalAddSize(color)" class="float-right">Tambah Ukuran</b-button>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ukuran</th>
                    <th>Stock</th>
                    <th>Min. Stock</th>
                    <th>unit</th>
                    <th>Harga Beli</th>
                    <th>Harga Jual</th>
                    <th>Harga Member</th>
                    <th>Harga Spesial Member</th>
                    <th>Harga Lebih 3</th>
                    <th>Harga Lebih 12</th>
                    <th>Harga Dropshipper</th>
                    <th>Harga Gold Member</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="size in color.product_size" :key="size.id">
                    <td>{{size.size.name}}</td>
                    <td>
                      <b-button size="sm" :id="'popover-' + size.id" variant="primary">{{size.stock}}</b-button>
                      <b-popover :target="'popover-' + size.id" triggers=" focus">
                        <template v-slot:title><strong>Kosongkan Stok</strong></template>
                        <b-button variant="danger" class="mt-2" @click="stockZero(size.id)">Kosongkan sekarang!</b-button>
                      </b-popover>
                    </td>
                    <td>{{size.min_stock !== null ? size.min_stock : 0}}</td>
                    <td>{{size.unit}}</td>
                    <td>{{formatNumber(size.capital_price)}}</td>
                    <td>{{formatNumber(size.selling_price)}}</td>
                    <td>{{formatNumber(size.member_price)}}</td>
                    <td>{{formatNumber(size.sm_price)}}</td>
                    <td>{{formatNumber(size.more_3)}}</td>
                    <td>{{formatNumber(size.more_12)}}</td>
                    <td>{{formatNumber(size.dropshipper)}}</td>
                    <td>{{formatNumber(size.gold_member)}}</td>
                    <td>
                      <b-button type="button" variant="primary" size="sm" @click="showModal(size)"><font-awesome-icon icon="edit"/></b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <!--<edit-button/>-->
        <back-button/>
      </card>
    </b-col>
    <b-modal ref="my-modal" centered hide-footer :title="(model.id === '' ? 'Tambah' : 'Perbarui') + ' Harga'">
      <form v-on:submit.prevent="doUpdated">
        <div>
          <fg-input :required="true" for-input="capitalPrice" type="number" name="capitalPrice" id="capitalPrice" label="Harga Modal" placeholder="Masukkan harga modal" v-validate="modelValidations.capitalPrice" :error="errors.first('capitalPrice')" v-model="data.capitalPrice" data-vv-as="harga modal" />
          <fg-input for-input="sellingPrice" type="number" name="sellingPrice" id="sellingPrice" label="Harga Jual" placeholder="Masukkan harga jual" v-model="data.sellingPrice" />
          <fg-input for-input="min_stock" type="number" name="min_stock" id="min_stock" label="Minimal Stok" placeholder="Masukkan minimal stok" v-model="data.min_stock" />
          <fg-input for-input="memberPrice" type="number" name="memberPrice" id="memberPrice" label="Harga Member" placeholder="Masukkan harga member" v-model="data.memberPrice" />
          <fg-input for-input="smPrice" type="number" name="smPrice" id="smPrice" label="Harga Spesial Member" placeholder="Masukkan harga spesial member" v-model="data.smPrice" />
          <fg-input for-input="more3" type="number" name="more3" id="more3" label="Harga Lebih Dari 3" placeholder="Masukkan harga lebih dari 3" v-model="data.more3" />
          <fg-input for-input="more12" type="number" name="more12" id="more12" label="Harga lebih dari 12" placeholder="Masukkan harga lebih dari 12" v-model="data.more12" />
          <fg-input for-input="dropshipper" type="number" name="dropshipper" id="dropshipper" label="Harga dropshipper" placeholder="Masukkan harga dropshipper" v-model="data.dropshipper" />
          <fg-input for-input="gold_member" type="number" name="gold_member" id="gold_member" label="Harga gold member" placeholder="Masukkan harga gold member" v-model="data.gold_member" />
          <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id !== undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading" />
          <b-button variant="warning" class="float-right mr-3" @click="hideModal">Cancel</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal ref="my-modal-photo-product" centered large hide-footer :title="'Photo Barang'">
      <form v-on:submit.prevent="doSubmitProductPhoto">
        <div>
          <fg-input for-input="name" type="text" name="name" id="name" label="Nama" placeholder="Masukkan nama barang" rows="10" v-model="dataPhoto.name"/>
          <label for="">Deskripsi</label>
          <vue-editor v-model="dataPhoto.description"></vue-editor>
          <fg-input label="Photo 1" for-input="fileinputGroupFile" :error="errors.first('photo1')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhoto1" ref="photo1" id="fileinputGroupFile" accept="image/*" name="photo1">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photo1 !== null ? dataPhoto.photo1.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photo1 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto1"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <fg-input label="Photo 2" for-input="fileinputGroupFile" :error="errors.first('photo2')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhoto2" ref="photo2" id="fileinputGroupFile" accept="image/*" name="photo2">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photo2 !== null ? dataPhoto.photo2.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photo2 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto2"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <fg-input label="Photo 3" for-input="fileinputGroupFile" :error="errors.first('photo3')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhoto3" ref="photo3" id="fileinputGroupFile" accept="image/*" name="photo3">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photo3 !== null ? dataPhoto.photo3.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photo3 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto3"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <fg-input label="Photo 4" for-input="fileinputGroupFile" :error="errors.first('photo4')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhoto4" ref="photo4" id="fileinputGroupFile" accept="image/*" name="photo4">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photo4 !== null ? dataPhoto.photo4.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photo4 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto4"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <b-button variant="primary" type="submit" class="float-right" :disaled="isLoadingPhoto"><font-awesome-icon v-if="isLoadingPhoto" icon="spinner" spin/><font-awesome-icon v-else icon="save"/> Submit</b-button>
          <b-button variant="warning" class="float-left mr-3" :disaled="isLoadingPhoto" @click="hideProductModal"><font-awesome-icon icon="times"/> Cancel</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal ref="my-modal-photo-color-product" centered hide-footer :title="'Photo Barang / Warna'">
      <form v-on:submit.prevent="doSubmitProductPhotoColor">
        <div>
          <fg-input :required="true" label="Warna" for-input="color" :error="errors.first('color')">
            {{dataPhoto.productColor}}
            <el-select size="large" id="color" name="color" v-validate="modelValidations.productColor" data-vv-as="color" v-model="dataPhoto.productColor" placeholder="Pilih color">
              <el-option v-for="option in model.category.product_color"  :value="option.id" :label="option.color.name" :key="option.id">
              </el-option>
            </el-select>
          </fg-input>
          <fg-input label="Photo" for-input="fileinputGroupFile" :error="errors.first('photoColor')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhotoColor" ref="photoColor" id="fileinputGroupFile" accept="image/*" name="photoColor">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photoColor !== null ? dataPhoto.photoColor.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photoColor !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhotoColor"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <b-button variant="primary" class="float-right" type="submit" :disabled="isLoadingPhotoColor"><font-awesome-icon v-if="isLoadingPhotoColor" icon="spinner" spin/><font-awesome-icon v-else icon="save"/> Submit</b-button>
          <b-button variant="warning" class="float-left mr-3" :disabled="isLoadingPhotoColor" @click="hideProductColorModal"><font-awesome-icon icon="times"/> Cancel</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal ref="my-modal-product-size-global" centered hide-footer :title="'Ukuran Barang Global'">
      <form v-on:submit.prevent="doSubmitProductSizeGlobal">
        <div>
          <fg-input :required="true" label="Warna" for-input="color" :error="errors.first('color')">
            {{dataPhoto.productColor}}
            <el-select size="large" id="color" name="color" v-validate="modelValidations.productColor" data-vv-as="color" v-model="dataPhoto.productColor" placeholder="Pilih color">
              <el-option v-for="option in model.category.product_color"  :value="option.id" :label="option.color.name" :key="option.id">
              </el-option>
            </el-select>
          </fg-input>
          <fg-input label="Photo" for-input="fileinputGroupFile" :error="errors.first('photoColor')">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" @change="onFileSelectedPhotoColor" ref="photoColor" id="fileinputGroupFile" accept="image/*" name="photoColor">
                <label class="custom-file-label" for="fileinputGroupFile">{{dataPhoto.photoColor !== null ? dataPhoto.photoColor.name : 'Choose file'}}</label>
              </div>
              <div v-if="dataPhoto.photoColor !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhotoColor"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </fg-input>
          <b-button variant="primary" class="float-right" type="submit" :disabled="isLoadingPhotoColor"><font-awesome-icon v-if="isLoadingPhotoColor" icon="spinner" spin/><font-awesome-icon v-else icon="save"/> Submit</b-button>
          <b-button variant="warning" class="float-left mr-3" :disabled="isLoadingPhotoColor" @click="hideProductColorModal"><font-awesome-icon icon="times"/> Cancel</b-button>
        </div>
      </form>
    </b-modal>
    <fab
      :position="position"
      :bg-color="bgColor"
      :actions="fabActions"
      @productModal="showProductModal"
      @productCOlorModal="showProductColorModal"
      @productSizeGlobalModal="showProductSizeGlobalModal"
      :icon-size="'small'"
    ></fab>
    <ModalAddSize ref="modal-add-size" v-on:getDetail="getDetail" />
  </b-row>
</template>

<script>
  import {Switch, Select, Option} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Viewer from 'v-viewer'
  import ModalAddSize from './ModalAddSize'
  import fab from 'vue-fab'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  // Advanced Use - Hook into Quill's API for Custom Functionality
  import { VueEditor } from 'vue2-editor'
  import Vue from 'vue'
  Vue.use(Viewer)

  export default {
    components: {
      LProgress,
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      EditButton: Edit,
      BackButton: Back,
      LSwitch: Switch,
      VueEditor,
      Treeselect,
      fab,
      ModalAddSize
    },
    data () {
      return {
        bgColor: '#7cc8df',
        position: 'bottom-right',
        fabActions: [
          {
            name: 'productModal',
            icon: 'camera_enhance',
            tooltip: 'Tambah Photo Barang',
            color: '#28a745'
          },
          {
            name: 'productCOlorModal',
            icon: 'camera',
            tooltip: 'Tambah Photo Barang / Warna',
            color: '#dc3545'
          },
          {
            name: 'productSizeGlobalModal',
            icon: 'format_size',
            tooltip: 'Tambah Ukuran Baju Global',
            color: '#007bff'
          }
        ],
        productSizeGlobalList: [],
        formProductSizeGlobal: {
          type: null,
          productId: null,
          size: [],
          photo: null
        },
        addProduct: false,
        isLoading: false,
        isLoadingPhoto: false,
        isLoadingPhotoColor: false,
        apiUrl: {
          product: window.AppConfig.apiUrl + 'product',
          productDetail: window.AppConfig.apiUrl + 'product-detail',
          productSizePrice: window.AppConfig.apiUrl + 'product-size-price',
          color: window.AppConfig.apiUrl + 'color',
          size: window.AppConfig.apiUrl + 'size',
          // kode: window.AppConfig.apiUrl + 'kode'
          name: window.AppConfig.apiUrl + 'name'
        },
        isFieldCode: false,
        setFieldCode: null,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        colorList: [],
        sizeList: [],
        lines: [{
          color: null,
          size: [],
          model: []
        }],
        blockRemoval: true,
        dataPhoto: {
          description: null,
          photo1: null,
          photo2: null,
          photo3: null,
          photo4: null,
          photoColor: null,
          productColor: null
        },
        model: {
          createdBy: {
            name
          },
          lastUpdatedBy: {
            name
          },
          code: '',
          name: '',
          category: {
            category: {
              name
            }
          },
          isActive: '',
          photo1: null,
          photo2: null,
          photo3: null,
          photo4: null
        },
        data: {
          id: null,
          min_stock: 0,
          capitalPrice: 0,
          sellingPrice: 0,
          memberPrice: 0,
          gold_member: 0,
          dropshipper: 0,
          smPrice: 0,
          more3: 0,
          more12: 0
        },
        modelValidations: {
          capitalPrice: {
            required: true
          },
          sellingPrice: {
            required: true
          },
          productColor: {
            required: true
          }
        }
      }
    },
    watch: {
      '$route.params.uuid': function (val) {
        this.getDetail()
      },
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      'addProduct': function (val) {
        if (val) {
          this.lines = [{
            color: null,
            size: [],
            model: []
          }]
          this.getColor()
          this.getSize()
        } else {
          this.lines = [{
            color: null,
            size: [],
            model: []
          }]
        }
      }
    },
    mounted () {
      this.getDetail()
    },
    methods: {
      editFieldCode () {
        this.setFieldCode = this.model.name
        this.isFieldCode = true
      },
      simpanFieldCode () {
        if (this.setFieldCode !== null && this.model.name !== null) {
          this.$swal({
            title: 'Are you sure?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            cancelButtonClass: 'btn btn-default',
            confirmButtonClass: 'btn btn-danger mr-3',
            buttonsStyling: false
          }).then(result => {
            if (result.value) {
              this.$http.patch(this.apiUrl.name, {
                id: this.$route.params.id,
                name: this.setFieldCode
              })
              .then(response => {
                this.isFieldCode = false
                this.getDetail()
                this.$store.dispatch('notification/success', 'Kode berhasil diubah.')
              })
              .catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          })
        }
      },
      batalFieldCode () {
        this.isFieldCode = !this.isFieldCode
      },
      ShowModalAddSize (color) {
        this.$refs['modal-add-size'].showModal(color)
      },
      getData (value, indexRow) {
        if (value.length <= this.lines[indexRow].model.length) {
          // removeItem()
          this.lines[indexRow].model.pop()
        } else {
          this.lines[indexRow].model.push({
            sizeId: value[value.length - 1],
            capitalPrice: 0,
            sellingPrice: 0,
            stock: 0
          })
        }
        // console.log(this.model.size)
      },
      addLine () {
        // let checkEmptyLines = this.lines.filter(line => line.color === null)
        // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          color: null,
          size: [],
          model: []
        })
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      getColor () {
        this.$http.get(this.apiUrl.color + '?limit=100').then(response => {
          this.colorList = []
          response.data.data.forEach(data => {
            this.colorList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getSize () {
        this.$http.get(this.apiUrl.size + '?limit=100').then(response => {
          this.sizeList = []
          response.data.data.forEach(data => {
            this.sizeList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.product + '/' + this.$route.params.id)
        .then(response => {
          this.model.createdBy = response.data.created_by
          this.model.lastUpdatedBy = response.data.last_updated_by
          this.model.code = response.data.code
          this.model.isActive = response.data.isActive
          this.model.name = response.data.name
          this.model.category = response.data.product_category
          this.dataPhoto.name = response.data.name
          this.dataPhoto.description = response.data.description
          this.model.description = response.data.description
          this.model.photo1 = response.data.photo_1
          this.model.photo2 = response.data.photo_2
          this.model.photo3 = response.data.photo_3
          this.model.photo4 = response.data.photo_4
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      doSubmitProductPhoto () {
        this.isLoadingPhoto = true
        let formData = new FormData()
        formData.append('name', this.dataPhoto.name)
        formData.append('description', this.dataPhoto.description)
        if (this.dataPhoto.photo1 !== null) {
          formData.append('title', 'test')
          formData.append('photo1', this.dataPhoto.photo1, this.dataPhoto.photo1.name)
        }
        if (this.dataPhoto.photo2 !== null) {
          formData.append('photo2', this.dataPhoto.photo2, this.dataPhoto.photo2.name)
        }
        if (this.dataPhoto.photo3 !== null) {
          formData.append('photo3', this.dataPhoto.photo3, this.dataPhoto.photo3.name)
        }
        if (this.dataPhoto.photo4 !== null) {
          formData.append('photo4', this.dataPhoto.photo4, this.dataPhoto.photo4.name)
        }
        this.$http.post(window.AppConfig.apiUrl + 'product-photo/' + this.$route.params.id, formData).then(() => {
          this.resetPhotoProduct()
          this.hideProductModal()
          this.getDetail()
          this.isLoadingPhoto = false
        }).catch(error => {
          this.isLoadingPhoto = false
          this.$store.dispatch('notification/error', error)
        })
      },
      doSubmitProductPhotoColor () {
        this.isLoadingPhotoColor = true
        let formData = new FormData()
        if (this.dataPhoto.photoColor !== null) {
          formData.append('photoColor', this.dataPhoto.photoColor, this.dataPhoto.photoColor.name)
        }
        this.$http.post(window.AppConfig.apiUrl + 'product-color-photo/' + this.dataPhoto.productColor, formData).then(() => {
          this.resetPhotoProductColor()
          this.hideProductColorModal()
          this.getDetail()
          this.isLoadingPhotoColor = false
        }).catch(error => {
          this.isLoadingPhotoColor = false
          this.$store.dispatch('notification/error', error)
        })
      },
      doSubmit () {
        this.saveButtonData.isLoading = true
        let model = {
          name: this.model.name,
          productCategory: {
            category: this.model.category.id,
            productColor: []
          }
        }
        this.lines.forEach((line, index) => {
          model.productCategory.productColor.push({
            color: line.color,
            productSize: []
          })
          line.model.forEach(productSize => {
            model.productCategory.productColor[index].productSize.push({
              size: productSize.sizeId,
              capitalPrice: productSize.capitalPrice,
              sellingPrice: productSize.sellingPrice,
              memberPrice: productSize.memberPrice,
              dropshipper: productSize.dropshipper,
              gold_member: productSize.gold_member,
              smPrice: productSize.smPrice,
              more3: productSize.more3,
              more12: productSize.more12,
              stock: productSize.stock
            })
          })
        })
        this.$http.post(this.apiUrl.productDetail, model).then(response => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/success', 'Warna berhasil di tambah.')
          this.addProduct = false
          this.getDetail()
        }).catch(error => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      resetPhotoProduct () {
        this.dataPhoto.photo1 = null
        this.dataPhoto.photo2 = null
        this.dataPhoto.photo3 = null
        this.dataPhoto.photo4 = null
      },
      resetPhotoProductColor () {
        this.dataPhoto.photoColor = null
        this.dataPhoto.productColor = null
        this.$validator.reset()
      },
      doSubmitProductSizeGlobal () {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          confirmButtonText: 'Yes',
          cancelButtonClass: 'btn btn-default',
          confirmButtonClass: 'btn btn-danger mr-3',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.post(window.AppConfig.apiUrl + 'product-size-global', {
              stock: 0
            })
            .then(response => {
              this.getDetail()
              this.$store.dispatch('notification/success', 'Stok berhasil dikosongkan.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      stockZero (productId) {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          confirmButtonText: 'Yes',
          cancelButtonClass: 'btn btn-default',
          confirmButtonClass: 'btn btn-danger mr-3',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.patch(window.AppConfig.apiUrl + 'product-zero' + '/' + productId, {
              stock: 0
            })
            .then(response => {
              this.getDetail()
              this.$store.dispatch('notification/success', 'Stok berhasil dikosongkan.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      changeSwitch (prop, label, value) {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-warning mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            let data = {}
            data[prop] = value
            data['uuid'] = this.$route.params.uuid
            this.$http.put(window.AppConfig.apiUrl + 'product' + '/' + this.$route.params.id, data)
            .then(response => {
              this.$store.dispatch('notification/success', label + ' Successfully updated.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
              this.model[prop] = value ? 0 : 1
            })
          } else {
            this.model[prop] = value ? 0 : 1
          }
        })
      },
      doUpdated () {
        this.data.more12 = parseInt(this.data.more12)
        console.log(this.data)
        this.$http.patch(this.apiUrl.productSizePrice + '/' + this.data.id, this.data).then(data => {
          this.$store.dispatch('notification/success', 'Harga product berhasil diperbaharui.')
          this.getDetail()
          this.hideModal()
        })
        .catch(error => {
          this.$store.dispatch('notification/error', error)
        })
      },
      showModal (value) {
        this.data.id = value.id
        this.data.capitalPrice = value.capital_price
        this.data.sellingPrice = value.selling_price
        this.data.memberPrice = value.member_price
        this.data.smPrice = value.sm_price
        this.data.more3 = value.more_3
        this.data.more12 = value.more_12
        this.data.dropshipper = value.dropshipper
        this.data.gold_member = value.gold_member
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      },
      showProductModal () {
        this.$refs['my-modal-photo-product'].show()
      },
      hideProductModal () {
        this.resetPhotoProduct()
        this.$refs['my-modal-photo-product'].hide()
      },
      showProductColorModal () {
        this.$refs['my-modal-photo-color-product'].show()
      },
      showProductSizeGlobalModal () {
        this.getProductSizeGlobal()
      },
      hideProductSizeGlobalModal () {
        this.$refs['my-modal-product-size-global'].hide()
      },
      hideProductColorModal () {
        this.resetPhotoProductColor()
        this.$refs['my-modal-photo-color-product'].hide()
      },
      getProductSizeGlobal () {
        this.$http.get(window.AppConfig.apiUrl + 'product-size-global/' + this.$route.params.id).then(resp => {
          this.productSizeGlobalList = resp.data
          this.formProductSizeGlobal.type = this.productSizeGlobalList.length > 0 ? 'Update' : 'Add'
          this.$refs['my-modal-product-size-global'].show()
        })
      },
      resetData (item) {
        this.data.id = null
        this.data.min_stock = 0
        this.model.capitalPrice = 0
        this.model.sellingPrice = 0
        this.data.memberPrice = 0
        this.data.smPrice = 0
        this.data.more3 = 0
        this.data.more12 = 0
        this.$validator.reset()
      },
      formatNumber (num) {
        if (num !== null) {
          return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
        } else {
          return 'Rp. ' + 0
        }
      },
      onFileSelectedPhoto1 (event) {
        this.dataPhoto.photo1 = event.target.files[0]
      },
      clearImagePhoto1 () {
        this.$refs.photo1.value = ''
        this.dataPhoto.photo1 = null
      },
      onFileSelectedPhoto2 (event) {
        this.dataPhoto.photo2 = event.target.files[0]
      },
      clearImagePhoto2 () {
        this.$refs.photo2.value = ''
        this.dataPhoto.photo2 = null
      },
      onFileSelectedPhoto3 (event) {
        this.dataPhoto.photo3 = event.target.files[0]
      },
      clearImagePhoto3 () {
        this.$refs.photo3.value = ''
        this.dataPhoto.photo3 = null
      },
      onFileSelectedPhoto4 (event) {
        this.dataPhoto.photo4 = event.target.files[0]
      },
      clearImagePhoto4 () {
        this.$refs.photo4.value = ''
        this.dataPhoto.photo4 = null
      },
      onFileSelectedPhotoColor (event) {
        this.dataPhoto.photoColor = event.target.files[0]
      },
      clearImagePhotoColor () {
        this.$refs.photoColor.value = ''
        this.dataPhoto.photoColor = null
      },
      getPath (imagePath) {
        return window.AppConfig.webUrl + imagePath
      }
    }
  }
</script>
<style scooped>
  .mt-4-5 {
    margin-top: 2rem !important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Products/Show.vue